import { request, query } from 'src/utils/request';

// 查询费控事件列表
export function getCostControlActionList (params) {
  return request('/api/davinci/rule/action/list', {
    params,
  });
}

// 根据费控事件查询费控规则列表
export function getCostControlStrategyList (params) {
  return request('/api/davinci/rule/strategy/pagelist', {
    params,
  });
}

// 费用规则标准查询
export function getCostStandardList (data) {
  return request('/zlb/cost/control/standard/page', {
    data,
    method: 'post'
  });
}

// 根据costControlId查询费控标准
export function getCostControlStandardDetail (params) {
  return request(`/zlb/cost/control/standard/get-by-id/${params.costControlId}`);
}

// 获取地址
export function fetchAddress (params) {
  return query('/zlb/api/expense/address', {
    method: 'GET',
    params,
  });
}

